module.exports = __webpack_public_path__ + "icon-play.378dda879b0eb401cf57.svg";


//////////////////
// WEBPACK FOOTER
// /Users/benmeden/Documents/Projects/Maestro/abem-examiner-demo/src/assets/icons/icon-play.svg
// module id = ../../../../../src/assets/icons/icon-play.svg
// module chunks = styles